<template>
  <h2 class="text-center">Choose a username</h2>
  <input
      type="text"
      v-model="username"
      class="form-control text-center"
      autofocus
      @keydown.enter="$emit('setUsername', username)"
  />
  <div class="flex justify-center gap-2">
    <button @click="$emit('setUsername', username)" class="btn btn-success w-full">
      Register
    </button>
  </div>
</template>

<script>
export default {
  name: "PlayerLobby",
  data() {
    return {
      username: null,
    };
  },
};
</script>
